import CustomButton from "components/CustomButton";
import CustomModal from "components/CustomModal";
import Input from "components/form/Input";
import { ImageUploadCard } from "components/ImageUploadCard";
import { isNotEmpty } from "helpers/stringHelper";
import isEmpty from "lodash/isEmpty";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DateTimePicker } from "components/datepicker/DatePicker";
import LabeledSelect from "components/selects/LabeledSelect";
import { tryCreatePredictionCategory, tryUpdatePredictionCategory } from "redux/slices/predictionSlice";
import { PREDICTION_OTHERS_LIST } from "./constant";
import { tryGetActiveFlashSale } from "redux/slices/bannerSlices";
import { isObjectEmpty } from "helpers/objectHelper";

import BrandSearchSelect from "components/selects/BrandSearchSelect";
import BrandWeekSelect from "components/selects/BrandWeekSelect";
import CampaignProductSelect from "components/selects/CampaignProductSelect";
import CategorySearchSelect from "components/selects/CategorySearchSelect";
import DynamicPagesSelect from "components/selects/DynamicPagesSelect";
import ProductSearchSelect from "components/selects/ProductSearchSelect";
import SpecialBrandsSelect from "components/selects/SpecialBrandsSelect";
import { PRODUCT_CAMPAIGN_TYPE } from "pages/focusItems/enums";
import { displayBrandWeekSearch, displayCampaignSearch, displayCategorySearch, displayBrandSearch, displayProductSearch, displayBrandDaySearch, displayProductCampaign } from "pages/banners/components/constants";
import { groupOptions } from "pages/banners/components/constants";
import { generateSeoUrl } from "./PredictionCandidateForm";
import { getReverseFormattedSeoUrl } from "helpers/seoHelper";
import { isFromOrigin } from "helpers/helperFunctions";



export default function PredictionCategoryForm({ loading, showModal, setShowModal }) {
  const dispatch = useDispatch()
  const intervalOptions = [
    {
      label: "Day",
      value: "DAY"
    },
    {
      label: "Campaign",
      value: "CAMPAIGN"
    },

  ]

  const {
    flashSale
  } = useSelector((state) => state.banner);

  const [title, setTitle] = useState("");
  const [image, setImage] = useState({
    app_banner_url: '',
    web_banner_url: '',
    app_image_url: '',
    web_image_url: ''
  });

  const [selectedGroup, setSelectedGroup] = useState({});
  const [group, setGroup] = useState('');
  const [subGroup, setSubGroup] = useState('');
  const [anylink, setAnyLink] = useState('')

  const groupSelectionOption = [...groupOptions, ...PREDICTION_OTHERS_LIST]

  // common for all search/select
  const [selectedOption, setSelectedOption] = useState(null);
  const [ext, setExt] = useState();
  const [seoDetail, setSeoDetail] = useState({});


  const [date, setDate] = useState("");
  const [frequency, setFrequency] = useState("");
  const [interval, setInterval] = useState("");

  useEffect(() => {
    if (!isEmpty(showModal) && showModal?.prediction_campaign_id) {
      if (showModal?.meta?.action_url) {
        const url = new URL(showModal?.meta?.action_url);
        let groupAndSubGroup = url.pathname.slice(1).split('/');
        const productsSubGroup = groupOptions[0].subGroupOptions.map(
          (option) => option.value
        );
        const selectedOption = groupOptions.filter(
          (option) => option.value === groupAndSubGroup[0]
        );
        resetIdTitleAndSelectedOption();

        if (
          groupAndSubGroup[0] === 'products' &&
          !productsSubGroup.includes(groupAndSubGroup[1])
        ) {
          setSubGroup('details');
        } else if (
          groupAndSubGroup[0] === 'brands' &&
          groupAndSubGroup[1] === undefined
        ) {
          setSubGroup('normal');
        } else if (
          groupAndSubGroup[0] === 'brands' &&
          groupAndSubGroup[1] !== 'featured'
        ) {
          setSubGroup('campaign');
        } else {
          setSubGroup(groupAndSubGroup[1]);
        }
        if (selectedOption[0]) {
          setSelectedGroup(selectedOption[0]);
          setGroup(selectedOption[0].value);
          const { name, id } = getReverseFormattedSeoUrl(
            groupAndSubGroup[groupAndSubGroup.length - 1]
          );
          if (selectedOption[0].label !== "Brands") {
            if (
              groupAndSubGroup[0] === 'products' &&
              !productsSubGroup.includes(groupAndSubGroup[1])
            ) {
              // setSelectedOption({id, label: name})
              setExt({ id, label: name });
            } else {
              setExt({ id, name });
              // setSelectedOption({id, name})
            }
          }
        } else {
          if (isFromOrigin(showModal?.meta?.action_url)) {
            setGroup("pages");
            const { name, id } = getReverseFormattedSeoUrl(
              groupAndSubGroup[groupAndSubGroup.length - 1]
            );
            setExt({ id, label: name });
          } else {
            setGroup("any_link")
            setAnyLink(showModal?.meta?.action_url)
          }
        }
      } else {
        setGroup('no_link')
      }

      setTitle(showModal?.title);
      setDate(showModal?.expiry_date)
      setFrequency(showModal?.rule_set?.frequency)
      setInterval(intervalOptions.find(x => x.value === showModal?.rule_set?.interval))
      setImage({
        app_banner_url: showModal.app_banner_url,
        web_banner_url: showModal.web_banner_url,
        app_image_url: showModal.app_image_url,
        web_image_url: showModal.web_image_url
      })
    }
    return () => {
      resetForm()
    }
  }, [showModal])

  const resetForm = () => {
    setTitle('')
    setImage({
      app_banner_url: '',
      web_banner_url: '',
      app_image_url: '',
      web_image_url: ''
    })
    setSelectedGroup({})
    setGroup('')
    resetIdTitleAndSelectedOption()
    setSeoDetail({})
    setExt()
    setDate("")
    setFrequency("")
    setInterval("")
    setAnyLink("")
  }

  const resetIdTitleAndSelectedOption = () => {
    setSelectedOption(null);
  };


  const onSubmit = () => {
    const url = generateSeoUrl(seoDetail, group, subGroup);
    dispatch(tryCreatePredictionCategory(
      {
        campaign_id: showModal.id,
        payload: {
          title,
          ...image,
          expiry_date: date,
          rule_set: {
            frequency: frequency,
            interval: interval?.value
          },
          meta: {
            ...(group !== 'no_link' && {
              action_url: group !== "any_link" ? url : anylink
            })
          }
        }
      }))
  }

  const onUpdate = () => {
    const url = generateSeoUrl(seoDetail, group, subGroup);
    dispatch(tryUpdatePredictionCategory(
      {
        id: showModal.id,
        payload: {
          title,
          ...image,
          expiry_date: date,
          rule_set: {
            frequency: frequency,
            interval: interval?.value
          },
          meta: {
            ...(group !== 'no_link' && {
              action_url: group !== "any_link" ? url : anylink
            })
          }
        }
      }))
  }

  const isAllValid = () => {
    const isImageValid = isNotEmpty(image.web_banner_url) && isNotEmpty(image.app_banner_url) && isNotEmpty(image.web_image_url) && isNotEmpty(image.app_image_url);


    const commonValid = isImageValid && isNotEmpty(title) && isNotEmpty(date);

    switch (group) {
      case 'products':
        if (
          subGroup === 'categories' ||
          subGroup === 'brand' ||
          subGroup === 'details' ||
          subGroup === 'brand_day' ||
          subGroup === 'brand_week'
        ) {
          return (
            commonValid && isNotEmpty(subGroup) && selectedOption !== null
          );
        } else {
          return commonValid && isNotEmpty(subGroup);
        }
      case 'brands':
        if (subGroup === 'campaign') {
          return (
            commonValid && isNotEmpty(subGroup) && isNotEmpty(seoDetail?.id)
          );
        } else {
          return commonValid && isNotEmpty(subGroup);
        }
      case 'flash-sale':
        if (flashSale.data !== null) {
          return (
            commonValid &&
            isNotEmpty(subGroup) &&
            isNotEmpty(flashSale.data?.id.toString())
          );
        } else {
          return false;
        }
      case 'product-campaigns':
        return commonValid && isNotEmpty(subGroup) && selectedOption !== null;
      case 'pages':
        return commonValid && !isEmpty(seoDetail);
      case 'no_link':
        return commonValid
      case 'any_link':
        return commonValid && isNotEmpty(anylink)
      default:
        return false;
    }
  };

  const onSetSelectedItem = (item) => {
    setSeoDetail(item);
    setSelectedOption(item);
  };

  const isEdit = showModal?.hasOwnProperty("prediction_campaign_id")

  return (
    <>
      <CustomModal
        title={isEdit ? 'Update' : 'Create'} children={
          <div className="flex space-x-4">
            <div className="flex-1">
              <ImageUploadCard
                title="Category App Image"
                initialImage={image.app_image_url}
                onImageUploaded={(uploaded) => {
                  setImage({ ...image, app_image_url: uploaded })
                }}
                onImageRemoved={(uploaded) => {
                  setImage({ ...image, app_image_url: uploaded })
                }}
              />
              <ImageUploadCard
                title="Category Web Image"
                initialImage={image.web_image_url}
                onImageUploaded={(uploaded) => {
                  setImage({ ...image, web_image_url: uploaded })
                }}
                onImageRemoved={(uploaded) => {
                  setImage({ ...image, web_image_url: uploaded })
                }}
              />
              <ImageUploadCard
                title="App Banner Image"
                initialImage={image.app_banner_url}
                onImageUploaded={(uploaded) => {
                  setImage({ ...image, app_banner_url: uploaded })
                }}
                onImageRemoved={(uploaded) => {
                  setImage({ ...image, app_banner_url: uploaded })
                }}
              />
              <ImageUploadCard
                title="Web Banner Image"
                initialImage={image.web_banner_url}
                onImageUploaded={(uploaded) => {
                  setImage({ ...image, web_banner_url: uploaded })
                }}
                onImageRemoved={(uploaded) => {
                  setImage({ ...image, web_banner_url: uploaded })
                }}
              />

            </div>
            <div className="flex-1 flex flex-col">
              <Input
                type="text"
                color="blue"
                placeholder="Title"
                value={title}
                onChange={(e) => {
                  setTitle(e.target.value)
                }}
              />
              <DateTimePicker
                name="Date"
                label="Expiry Date"
                isRequired={true}
                selectedDate={date ?? ''}
                onChange={(value) => {
                  setDate(value)
                }}
                convertToUTC={true}
              />
              <Input
                type="number"
                color="blue"
                placeholder="Frequency"
                value={frequency}
                onChange={(e) => {
                  setFrequency(parseInt(e.target.value))
                }}
              />
              <LabeledSelect
                label="Interval"
                placeholder="Select Interval"
                options={intervalOptions}
                value={
                  intervalOptions?.find(
                    (o) => o?.value === interval.value,
                  ) ?? ''
                }
                onChange={(selectedOption) => {
                  setInterval(selectedOption)
                }}
              />

              <div className="flex-1 flex flex-col p-4 border rounded-lg bg-secondary-100">
                <>
                  <div className="font-base mb-4">[ Banner Redirection ]</div>
                  <LabeledSelect
                    label="Select Group"
                    placeholder="Search Group"
                    options={groupSelectionOption}
                    value={groupSelectionOption.find((o) => o.value === group) ?? ''}
                    onChange={(selectedOption) => {
                      setSelectedGroup(selectedOption);
                      setGroup(selectedOption.value);
                      setSubGroup('');
                      resetIdTitleAndSelectedOption();
                      if (selectedOption.value === 'flash-sale') {
                        setSeoDetail({});
                        dispatch(tryGetActiveFlashSale());
                      }
                    }}
                    maxHeight={170}
                  />

                  {group !== 'flash-sale' &&
                    group !== 'product-campaigns' &&
                    group !== 'pages' && group !== 'no_link' && group !== 'any_link' &&
                    <LabeledSelect
                      label={`Select Sub Group`}
                      placeholder="Search Sub Group"
                      options={selectedGroup.subGroupOptions}
                      isDisabled={isObjectEmpty(selectedGroup)}
                      value={
                        selectedGroup?.subGroupOptions?.find(
                          (o) => o.value === subGroup
                        ) ?? ''
                      }
                      onChange={(selectedOption) => {
                        setSubGroup(selectedOption.value);
                        onSetSelectedItem();
                        resetIdTitleAndSelectedOption();
                      }}
                      maxHeight={120}
                    />
                  }

                  {
                    group === 'product-campaigns' && (
                      <LabeledSelect
                        label={'Select Campaign Type'}
                        value={PRODUCT_CAMPAIGN_TYPE.find(
                          (t) => t.value === subGroup
                        )}
                        options={PRODUCT_CAMPAIGN_TYPE}
                        placeholder={'Select Campaign Type'}
                        onChange={(v) => {
                          setSelectedOption(null);
                          setSubGroup(v.value);
                        }}
                      />
                    )
                  }

                  {
                    group === 'pages' &&
                    <DynamicPagesSelect
                      label="Select a Dynamic Page"
                      value={selectedOption}
                      extData={ext?.id}
                      onChange={(page) => {
                        onSetSelectedItem(page);
                      }}
                    />

                  }


                  {/*Brand search section*/}
                  {displayBrandSearch(group, subGroup) && (
                    <BrandSearchSelect
                      label="Select Brand"
                      isDisabled={false}
                      value={selectedOption}
                      extData={ext?.id}
                      onChange={(brand) => onSetSelectedItem(brand)}
                    />
                  )}

                  {/*Product search section*/}
                  {displayProductSearch(group, subGroup) && (
                    <ProductSearchSelect
                      label="Select Product"
                      isDisabled={false}
                      extData={ext?.id}
                      value={selectedOption}
                      onChange={(product) => onSetSelectedItem(product)}
                    />
                  )}

                  {/*Category search section*/}
                  {displayCategorySearch(group, subGroup) && (
                    <CategorySearchSelect
                      label="Select Category"
                      isDisabled={false}
                      value={selectedOption}
                      extData={ext?.id}
                      onChange={(category) => onSetSelectedItem(category)}
                    />
                  )}

                  {displayCampaignSearch(group, subGroup) && (
                    <SpecialBrandsSelect
                      label="Select Campaign Month"
                      isBrandDay={false}
                      value={selectedOption}
                      extData={ext?.id}
                      onChange={(campaign) => onSetSelectedItem(campaign)}
                    />
                  )}

                  {displayBrandDaySearch(group, subGroup) && (
                    <SpecialBrandsSelect
                      label="Select Brand Day"
                      emptyMsg="No brand day available"
                      extData={ext?.id}
                      isBrandDay={true}
                      value={selectedOption}
                      onChange={(brand) => onSetSelectedItem(brand)}
                    />
                  )}

                  {displayBrandWeekSearch(group, subGroup) && (
                    <BrandWeekSelect
                      extData={ext?.id}
                      label="Select Brand Week"
                      emptyMsg="No brand week available"
                      value={selectedOption}
                      onChange={(brand) => onSetSelectedItem(brand)}
                    />
                  )}

                  {displayProductCampaign(group, subGroup) && (
                    <CampaignProductSelect
                      label="Search Product Campaign"
                      value={selectedOption}
                      onChange={(campaign) => {
                        onSetSelectedItem(campaign);
                      }}
                      type={subGroup}
                    />
                  )}
                  {group === 'any_link' &&
                    <Input
                      type="text"
                      color="blue"
                      label="Link (must be a valid https:// url)"
                      placeholder="Eg: https://example.com"
                      value={anylink}
                      onChange={(e) => {
                        setAnyLink(e.target.value.trim())
                      }}
                    />

                  }
                  {group === 'flash-sale' && (flashSale.loading ?
                    <div>'Checking active flash sale...'</div> : flashSale.error ?
                      <div>'Checking active flash sale...'</div>
                      : flashSale.data !== null ?
                        <LabeledSelect
                          label="Select Sub Group"
                          placeholder="Search Sub Group"
                          options={selectedGroup.subGroupOptions}
                          isDisabled={isObjectEmpty(selectedGroup)}
                          value={
                            selectedGroup?.subGroupOptions?.find(
                              (o) => o.value === subGroup
                            ) ?? ''
                          }
                          onChange={(selectedOption) => {
                            setSubGroup(selectedOption.value);
                            resetIdTitleAndSelectedOption();
                          }}
                          maxHeight={120}
                        /> :

                        <div>No Flash Sale currently running</div>
                  )}

                </>
              </div>
            </div>
          </div>
        }
        showModal={!!showModal}
        button={
          <CustomButton onClick={isEdit ? onUpdate : onSubmit} disabled={loading || !isAllValid()}>
            {isEdit ? 'Update' : 'Create'}
          </CustomButton>
        }
        setShowModal={() => {
          setShowModal()
        }}
        loading={loading}
      />
    </>
  );
}
